import { notification } from 'antd';

const TIMEOUT_STATUS_CODES = [502, 503, 504];

const TIMEOUT_MESSAGES: Record<number, string> = {
  502: 'Bad Gateway — The server received an invalid response. Please try again.',
  503: 'Service Unavailable — The server is temporarily unable to handle the request.',
  504: 'Request Timed Out — The server took too long to respond. Please try again.',
};

let interceptorInstalled = false;

export const installFetchInterceptor = (): void => {
  if (interceptorInstalled) return;
  interceptorInstalled = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args: Parameters<typeof fetch>): Promise<Response> => {
    try {
      const response = await originalFetch(...args);

      if (TIMEOUT_STATUS_CODES.includes(response.status)) {
        const msg = TIMEOUT_MESSAGES[response.status] || 'Request timed out. Please try again.';
        notification.error({
          message: 'Connection Error',
          description: msg,
          duration: 6,
          placement: 'topRight',
        });
      }

      return response;
    } catch (error: any) {
      // Network-level timeout or connection refused
      const isTimeout =
        error?.name === 'AbortError' ||
        error?.message?.toLowerCase().includes('timeout') ||
        error?.message?.toLowerCase().includes('network') ||
        error?.message?.toLowerCase().includes('failed to fetch');

      if (isTimeout) {
        notification.error({
          message: 'Request Timed Out',
          description: 'The request could not be completed. Please check your connection and try again.',
          duration: 6,
          placement: 'topRight',
        });
      }

      throw error;
    }
  };
};
